export default {
  'claimCount': 'Claim Count',
  'totalClaimsCompletedByDayMonth': 'Total Claims Completed by Day/Month',
  'byMonthAndStatus': 'Claims By Month and Status',
};